import React from 'react';
import s from '../PaperworkList.module.css';
import {FilterPaperworkButton} from '../../../types/TypesDepotPaperwork';
type Props = {
	buttons: FilterPaperworkButton[];
};
const PaperworkFilterButtons: React.FC<Props> = ({buttons}) => {
	return (
		<div className={s.filtersContainer}>
			{buttons.map((button) => (
				<button
					type={'button'}
					onClick={() => button.callback(button.id)}
					key={button.id}
					className={`${s.filtersContainerItem} ${button.active ? s.active : ''}`}
				>
					{button.name}
				</button>
			))}
		</div>
	);
};

export default PaperworkFilterButtons;
